import React, { useEffect, useState } from 'react';
import { useAppState } from "../../../AppListenerProvider";
import { useAuth } from "../../../AuthProvider";
import { useDeepLink } from "../../../DeepLinkProvider";
import AuthService from "../../../services/auth.service";
import AuthenticationButtons from "../AuthenticationButtons/AuthenticationButtons";
import OnboardingPageWrapper from "../OnboardingPageWrapper/OnboardingPageWrapper";
import WelcomeHelp from '../WelcomeHelp/WelcomeHelp';

interface WelcomeSignUpAuthProps {
    title: string;
    showBackButton: boolean;
    showSkipButton: boolean;
    handleAuthedStep: () => void;
    handleEmailAuthStep: () => void;
    onBack?: () => void;
}

const WelcomeSignUpAuth: React.FC<WelcomeSignUpAuthProps> = ({
    showSkipButton,
    showBackButton,
    title,
    handleAuthedStep,
    handleEmailAuthStep,
    onBack
}) => {
    const { isActive, isNative, platform } = useAppState();
    const { user, isLoading, isAuthenticated, firebaseApp, auth } = useAuth();
    const authService = AuthService({ user, isLoading, isAuthenticated, firebaseApp, auth }, {
        isActive,
        isNative,
        platform
    });

    const { deepLinkData, clearDeepLinkData } = useDeepLink();
    const [referral, setReferral] = useState<string | null>(null);

    useEffect(() => {
        if (deepLinkData.slug) {
            console.log("Handling deep link in onboarding:", deepLinkData.slug);
            if (deepLinkData.slug.startsWith('/share') && deepLinkData.referrer) {
                setReferral(deepLinkData.referrer);
                console.log(`Referral from: ${deepLinkData.referrer}`);
            }
        }
    }, [deepLinkData]);

    const handleAuthStep = () => {
        handleAuthedStep();
    };

    const handleEmailStep = () => {
        handleEmailAuthStep?.();
    };

    return (
        <OnboardingPageWrapper title={title} showBackButton={showBackButton} showSkipButton={showSkipButton} onBack={onBack}>
            <AuthenticationButtons
                login={false}
                authService={authService}
                platform={platform}
                handleAuthedStep={handleAuthStep}
                handleEmailAuthStep={handleEmailStep}
            />
            <WelcomeHelp />
            {referral && (
                <div className="text-sm text-primary-alt text-center">
                    Referred by: <span className="text-electric-blue">{referral}</span>
                </div>
            )}
        </OnboardingPageWrapper>
    );
};

export default WelcomeSignUpAuth;